import Mascot from '@/components/Mascot';

/** Preview page per vedere tutte le pose del contadino mascotte. Dev only. */
export default function MascotPreview() {
  const poses = ['wave', 'search', 'welcome', 'analyze', 'lost', 'basket', 'point', 'celebrate'];
  return (
    <div className="min-h-screen p-10 bg-background">
      <h1 className="font-display text-4xl tracking-tighter mb-10">Mascot preview</h1>
      <div className="grid grid-cols-2 md:grid-cols-5 gap-6">
        {poses.map(p => (
          <div key={p} className="rounded-2xl border border-border bg-card p-6 flex flex-col items-center">
            <Mascot pose={p} size={160}/>
            <div className="mt-4 text-sm font-medium">{p}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
